<template>
    <v-navigation-drawer
        v-model="active"
        right
        fixed
        temporary
        width="600"
    >
        <v-container class="pa-10" v-if="vehicle">
            <v-row>
                <v-col cols="12">
                    <v-row no-gutters class="center">
                        <v-btn icon class="black--text" @click="onBackSelected">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <span class="headline">Editar Vehiculo</span>
                    </v-row>
                </v-col>
            </v-row>

            <validation-observer ref="form">
                <v-form>
                    <v-row>
                        <v-col cols="12">
                            <validation-provider name="name" v-slot="{ errors }" rules="required">
                                <v-text-field
                                    v-model="data.name"
                                    label="Nombre"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <validation-provider name="makeAndModel" v-slot="{ errors }" rules="required">
                                <v-text-field
                                    v-model="data.makeAndModel"
                                    label="Marca y Modelo"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <validation-provider name="license" v-slot="{ errors }" rules="required">
                                <v-text-field
                                    v-model="data.license"
                                    label="Patente"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <validation-provider name="capacity" v-slot="{ errors }" rules="required">
                                <v-text-field
                                    v-model="data.capacity"
                                    label="Capacidad"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                label="Características"
                                v-model="data.features"
                                :items="features"
                                item-text="name"
                                item-value="id"
                                return-object
                                multiple
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </validation-observer>
        </v-container>

        <template v-slot:append>
            <v-row class="ma-4">
                <v-spacer></v-spacer>

                <v-btn color="green" dark block @click="onSaveSelected" :loading="isLoading">Guardar</v-btn>
            </v-row>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },

        props: {
            value: {
                type: Boolean,
                default: false
            },

            vehicle: {
                type: Object,
                default: null
            }
        },

        data() {
            return {
                active: false,
                data: {}
            };
        },

        computed: {
            isLoading() {
                return this.$store.getters['vehicles/isLoading']();
            },

            features() {
                return this.$store.getters['vehicleFeatures/getAll']();
            }
        },

        watch: {
            active(val) {
                this.$emit('input', val);
            },

            value(val) {
                this.active = val;
            },

            vehicle: {
                immediate: true,
                async handler(e) {
                    if(!e) {
                        return;
                    }

                    await this.$store.dispatch('vehicles/fetchOne', { id: this.vehicle.id });

                    this.data = {
                        name: e.name,
                        makeAndModel: e.makeAndModel,
                        license: e.license,
                        features: e.features,
                        capacity: e.capacity
                    };
                }
            }
        },

        mounted() {
            this.$store.dispatch('vehicleFeatures/fetchAll');
        },

        methods: {
            onBackSelected() {
                this.active = false;
            },

            async onSaveSelected() {
                let result = await this.$refs.form.validate();
                if(!result) {
                    return;
                }

                try {
                    let payload = { ...this.data };
                    payload.features = payload.features.map((item) => item.id);

                    await this.$store.dispatch('vehicles/patch', { vehicle: this.vehicle, data: payload });

                    this.$store.dispatch('app/setStatusMessage', 'Cambios guardados');
                }
                catch (err) {
                    let formErrors = {};

                    for(let errField in err.errors) {
                        formErrors[errField] = this.$t(err.errors[errField]);
                    }

                    this.$refs.form.setErrors(formErrors);
                }
            },

            addFeature(feature) {
                this.data.features.push(feature);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .v-chip.small {
        height: 20px;
    }
</style>
